module.exports = __webpack_public_path__ + "bin/71a4fe463a753413efe0b01f24b33537.png";